import { invoke } from '@yoda/bridge';
import type { ComputedRef } from 'vue';

export interface Option {
    isLogin: ComputedRef<boolean>;
    afterLogin: () => void;
}

export const useUnLoginGuard = (option: Option) => {
    const { isLogin, afterLogin } = option;
    const unLoginGuard = () => {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
            if (!isLogin.value) {
                // 没登录
                console.log('----not---login-----');
                reject();
                // 吊起登录
                console.log('start login');
                try {
                    const { result } = await invoke('social.login', {
                        checkFromServer: true,
                        loginSource: 51,
                    });
                    afterLogin();
                } catch (e) {
                    await invoke('ui.showToast', {
                        type: 'normal',
                        text: '登录失败',
                    });
                }
            } else {
                // @ts-expect-error
                resolve();
            }
        });
    };

    return {
        unLoginGuard,
    };
};
